import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal, Space } from "antd";
import "./edit_data_table_good_receive_return.css";
import LocationCodeRackGoodsReceiveReturn from "./location_code_rack_goods_receive_return";

interface TableDataType {
    key: React.Key;
    item_code: string;
    item_name: string;
    case: number;
    uom: string;
    uom_rate: number;
    location: string;
    ref: string;
    do: string;
    receive: number;
    return_qty: number;
    qty: number;
    return: number;
    item_price: number;
    remark: string;
    do_no: string;
    discount_per_item?: string
}

interface EditDataTableProps {
    record: TableDataType | null;
    onCancel: () => void;
    onOk: (values: TableDataType) => void;
    warehouse?: string;
}

const EditDataTableGoodsReceive: React.FC<EditDataTableProps> = ({ record, onCancel, onOk, warehouse }) => {
    const [form] = Form.useForm();
    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);

    useEffect(() => {
        if (record) {
            form.setFieldsValue(record);
        } else {
            form.resetFields();
        }
    }, [record, form]);

    const handleFinish = (values: any) => {
        if (record) {
            onOk({ ...record, ...values });
        }
    };

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const handleCancel = () => {
        onCancel();
    };

    return (

        <div id="ieml" style={transformStyle}>
            <div className="gjs-grid-row" id="ii3x">
                <div className="gjs-grid-column" id="inhb">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onFinish={handleFinish}
                    >
                        <Form.Item
                            label="Item Code"
                            name="item_code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Case"
                            name="case"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="UOM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="UoM Rate"
                            name="uom_rate"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item label="Location Code" style={{ marginBottom: "5px" }}>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item name="location" noStyle style={{ width: "85%" }}>
                                    <Input placeholder="" style={{ width: "90%" }} readOnly/>
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="location_code_rack_goods_receive_return"
                                    onClick={() => setIsLocationModalOpen(true)}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Ref"
                            name="ref"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="QTY. Receive"
                            name="receive"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="QTY. Return"
                            name="return"
                            dependencies={['receive', 'return_qty']}
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const sisa = Number(getFieldValue('receive') || 0) - Number(getFieldValue('return_qty') || 0);
                                        if (!value || Number(value) <= sisa) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(`Maksimal return adalah ${sisa} !`));
                                    },
                                }),
                                { required: true, message: 'required !' }
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Item Price"
                            name="item_price"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                formatter={(value) => new Intl.NumberFormat('id-ID').format(value as number)}
                                parser={(value) => value!.replace(/\./g, '')}
                                placeholder=""
                                readOnly
                            />
                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'required !' }]}
                        >
                            <Input.TextArea rows={4} placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="DO No"
                            name="do_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Space style={{ paddingTop: "20px" }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}>
                                        <path
                                            fillRule="evenodd"
                                            d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }>
                                OK
                            </Button>
                            <Button
                                type="primary"
                                onClick={handleCancel}
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                }}>
                                Cancel
                            </Button>
                        </Space>
                    </Form>
                    <Modal
                        title="Location Code Rack"
                        open={isLocationModalOpen}
                        onCancel={() => setIsLocationModalOpen(false)}
                        footer={null}
                        width={800}
                    >
                        <LocationCodeRackGoodsReceiveReturn
                            warehouse={warehouse}
                            onSelectLocation={(code) => {
                                form.setFieldsValue({ location: code });
                                setIsLocationModalOpen(false);
                            }}
                        />
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default EditDataTableGoodsReceive;